import { useEffect } from 'react';
import Highcharts from 'highcharts/highstock';
import { ingMeWebRegular } from 'common-react';

type UseHighchartsSharedSetupParams = Partial<{
  shortMonths: string[];
  proxyPositionResetTrigger: unknown;
}>;

export const useHighchartsSharedSetup = ({
  shortMonths,
  proxyPositionResetTrigger,
}: UseHighchartsSharedSetupParams = {}) => {
  useEffect(() => {
    Highcharts.setOptions({
      chart: {
        style: {
          fontFamily: ingMeWebRegular,
        },
      },
      ...(shortMonths ? {
        lang: {
          shortMonths,
        },
      } : {}),
    });
  }, [shortMonths]);

  // FLADEV2-4223 - This is a workaround to reset highcharts proxy elements position.
  useEffect(() => {
    const proxyElements = document.querySelectorAll('.highcharts-a11y-proxy-element.highcharts-no-tooltip');
    if (proxyElements) {
      proxyElements.forEach(element => {
        (element as HTMLElement).style.top = 'initial';
      });
    }
  }, [proxyPositionResetTrigger]);
};
